import { useState, useEffect, useRef } from 'react';
import * as propz from 'propz';
import { Tournament } from 'models/tournament';
import { SchoolEvent } from 'models/event';
import {
  getAllTournamentEvents,
} from 'services/Tournaments/events';

interface UseTournamentTVDataResult {
  events:      SchoolEvent[];
  isSync:      boolean;
}

export function useTournamentTVData(
  tournament: Tournament
): UseTournamentTVDataResult {
  const [ events, setEvents ] = useState<SchoolEvent[]>([]);
  const [ isSync, setIsSync ] = useState(false);

  const REFRESH_INTERVAL = 30_000;
  const refreshTimerRef = useRef<number | null>(null);

  const loadData = async () => {
    const schoolId     = propz.get(tournament, ['schoolId'], '') as string;
    const tournamentId = propz.get(tournament, ['id'], '') as string;

    try {
      const allEvents: SchoolEvent[] = await getAllTournamentEvents(schoolId, tournamentId);
      console.log('[TV] fetched allEvents:', allEvents.length, 'items:', allEvents);
      setEvents(allEvents);
    } catch (e) {
      console.error('Error fetching tournament events:', e);
      setEvents([]);
    }

    setIsSync(true);
  };

  useEffect(() => {
    loadData();

    refreshTimerRef.current = window.setInterval(loadData, REFRESH_INTERVAL);

    return () => {
      if (refreshTimerRef.current !== null) {
        clearInterval(refreshTimerRef.current);
      }
    };
  }, [tournament]);

  return { events, isSync };
}
